RivalIQ.module('views.metric', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const CompanyCountCellPopoverRow = Marionette.ItemView.extend({
        tagName: 'tr',
        template: function (data) {
            let className = '';
            if (data.isFocus) {
                className = 'text-highlight';
            }

            const template = _.template(
                `<td class="${className}"><%- dimensionValue %></td>` +
                '<td align="right"><%- metricValue %></td>');

            return template(data);
        }
    });

    const CompanyCountCellPopover = views.CompanyCountCellPopover = Marionette.CompositeView.extend({
        limit: 10,
        className: 'company-count-cell-popover',
        template: '#companyCountCellPopoverTemplate',
        childView: CompanyCountCellPopoverRow,
        childViewContainer: 'tbody',
        initialize: function (options) {
            const me = this;

            const data = options.data;
            const metrics = options.metrics;

            const attrs = {
                companyId: undefined,
                dimensions: ['companyId']
            };
            const valueMetric = _.last(metrics);

            // NOTE if a dimension is specified in attributes, and the metric
            // was not already configured for it then we should apply it so
            // that we can get the right values
            // NOTE this assumes that there is only one other free metric
            // (i.e., that the dimensions array is size three)
            const dimension = valueMetric.get('dimension');
            const freeDimensions = valueMetric.getFreeDimensions();
            if (dimension && _.size(data) - 1 > _.size(attrs.dimensions) && !_.includes(attrs.dimensions, dimension)) {
                attrs.dimensions.splice(0, 0, dimension);
                freeDimensions.push(dimension);
            }

            const landscapeMetric = _.extend(valueMetric.build(attrs), {
                data: valueMetric.data
            });

            _.each(freeDimensions, function (freeDimension, i) {
                _.set(landscapeMetric, ['attributes', freeDimension], data[i]);
            });

            const landscapeValues = landscapeMetric.getValue({
                format: false
            });
            const sortedValues = _.sortBy(landscapeValues, function (values) {
                return _.last(values) * -1;
            });

            const limit = Marionette.getOption(me, 'limit');
            const models = _.map(_.take(sortedValues, limit), function (values) {
                const companyId = parseInt(_.head(values));
                const company = RivalIQ.state.landscape.getCompanyById(companyId);

                const attrs = {
                    companyId: companyId
                };

                const focusMetric = _.extend(landscapeMetric.build(attrs), {
                    data: landscapeMetric.data
                });

                return {
                    isFocus: (companyId === RivalIQ.state.utils.getFocusedCompanyId()),
                    dimensionValue: company.get('name'),
                    metricValue: focusMetric.getValue()
                };
            });

            me.collection = new Backbone.Collection(models);
        },
        serializeData: function () {
            const me = this;

            const data = Marionette.getOption(me, 'data');
            const count = _.last(data);

            const metrics = Marionette.getOption(me, 'metrics');
            const countMetric = _.head(metrics);
            const valueMetric = _.last(metrics);

            const freeDimension = _.head(countMetric.getFreeDimensions());
            let value = Marionette.getOption(me, 'popoverName');

            if (!value) {
                value = RivalIQ.metric.format.formatDimension({
                    property: 'name',
                    dimensions: [freeDimension]
                }, freeDimension, _.head(data));
                if (value === '#__SUMMARY_ROW__') {
                    value = 'Summary Row';
                }
            }

            const limit = Marionette.getOption(me, 'limit');
            return {
                value: value,
                countVisible: Math.min(limit, count),
                count: count,
                dimensionName: 'Company',
                metricName: RivalIQ.utils.text.abbreviate(valueMetric.getName())
            };
        }
    });

    views.CompanyCountCell = {
        tagName: 'td',
        className: 'metric-table-cell text-center',

        getPopover: function (data, metric, metrics) {
            return new CompanyCountCellPopover({
                data: data,
                metrics: metrics
            });
        },

        render: function (metric, data) {
            const me = this;

            if (!_.last(data)) {
                return;
            }

            // focus here will be a metric with the number of times the
            // focusCompanyId used that dimension metric (e.g., `hashtag`).
            // that submetric is defined in the `companies_using` metric expansion.
            const focus = metric.get('submetrics').first();

            const attrs = {
                // NOTE we need to use `concat` here to clone the dimensions
                // array because it is a reference (i.e., we don't want to
                // accidentally mutate the `focus` metric)
                dimensions: [].concat(focus.getDimensions())
            };

            // NOTE if a dimension is specified in attributes, and the metric
            // was not already configured for it then we should apply it so
            // that we can get the right values
            // NOTE this assumes that there is only one other free metric
            // (i.e., that the dimensions array is size three)
            const dimension = focus.get('dimension');
            if (dimension && _.size(data) > _.size(attrs.dimensions) && !_.includes(attrs.dimensions, dimension)) {
                attrs.dimensions.splice(1, 0, dimension);
            }

            // NOTE for each free metric we should assign a value from the data
            const focusMetric = _.extend(focus.build(attrs), {
                data: focus.data
            });
            _.each(focusMetric.getFreeDimensions(), function (freeDimension, i) {
                _.set(focusMetric.attributes, freeDimension, data[i]);
            });

            const focusCompanyValue = focusMetric.getValue({
                format: false
            });

            const classes = ['hashtag-company-count'];
            if (focusCompanyValue > 0) {
                classes.push('includes-focus-company');
            }

            const metrics = [metric];
            const companyUsingPopoverMetric = metric.collection.find(function (m) {
                return m.get('isCompanyUsingPopoverMetric');
            });

            if (!companyUsingPopoverMetric) {
                // NOTE we will try to show the metric following the usage pill
                // if we find one (this will depend on the table, and if we don't
                // happen to find one then we will fall back to the company count)
                //
                // vvv A LINK TO THE SPECFICIATION IS BELOW vvv
                // https://github.com/RivalIQ/rivaliq-server/issues/14507#issuecomment-352906385
                const nextMetric = metric.collection.at(metric.collection.indexOf(metric) + 1);
                if (nextMetric) {
                    metrics.push(nextMetric);
                }
            } else {
                // NOTE the developer (or someone adjacent to a developer) has
                // specified a specific metric to use in the popover; please
                // understand that THE FIRST METRIC with the flag set will be
                // used, and others will be ignored
                metrics.push(companyUsingPopoverMetric);
            }

            const popover = me.getPopover(data, metric, metrics);

            return $.tagHtml('span', {
                class: classes,
                'data-content': popover.render().el.outerHTML,
                'data-html': true,
                'data-placement': 'auto',
                'data-toggle': 'popover',
                'data-trigger': 'hover',
                text: _.last(data)
            });
        }
    };

    views.PresenceIcon = {
        tagName: 'td',
        className: 'presence-icon text-center',
        render: function (metric, data) {
            const template = Marionette.TemplateCache.get('#presenceIconTemplate');

            const nameMetric = metric.build({
                property: 'name'
            });
            nameMetric.data = metric.data;

            const companyId = _.head(data);
            const companyName = _.reduce(nameMetric.getValue(), function (memo, datum) {
                return _.head(datum) === companyId ? _.last(datum) : memo;
            }, null);

            return template({
                abbr: RivalIQ.utils.companyDisplay.getNameAbbreviation(companyName),
                iconUrl: _.last(data)
            });
        }
    };

    views.PeopleUsingCountCell = {
        tagName: 'td',
        className: 'metric-table-cell text-center',
        render: function (metric, data) {
            if (!_.last(data)) {
                return;
            }

            const classes = ['hashtag-company-count'];
            return $.tagHtml('span', {
                class: classes,
                text: _.last(data)
            });
        }
    };

    views.Bar = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'metric-table-cell',
        template: '#metricBarCellTemplate',

        serializeData: function () {
            const me = this;
            const data = me.getOption('data');
            const bounds = me.getOption('bounds');
            const name = me.model.getName();
            const value = (!data || _.last(data) === null ? '--' : me.model.formatExpanded(data));
            const showSourceIcons = me.getOption('table').dashboardModel.getCuration().isCustomDashboard;
            const tooltip = Marionette.TemplateCache.get('#tableCellTooltip')({
                name: name,
                value: value,
                sourceIcon: (showSourceIcons ? RivalIQ.enums.sourceDetails[me.model.getSource()].iconSvg : null)
            });
            const color = me.color || me.model.color(data);
            const showProgressBar = _.isUndefined(me.model.get('showProgressBar')) || me.model.get('showProgressBar');
            let labelClass = '';

            const timeAnalysisMode = me.model.get('timeAnalysisMode');
            if (timeAnalysisMode === RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE) {
                labelClass = RivalIQ.formatter.relativeMetricClass(_.last(data));
            }

            const {primaryDimension, primaryDimensionId, calculationMetadata} = me.model.getPrimaryDimensionAndCalculationMetadata(data);
            let partialDataPopover = null;
            if (!_.isEmpty(_.get(calculationMetadata, ['missingSources'])) && !_.get(calculationMetadata, ['missingAllSources'])) {
                partialDataPopover = RivalIQ.utils.incompleteData.getIncompleteDataPopover(primaryDimension, primaryDimensionId, me.model, calculationMetadata);
            } else if (primaryDimension === 'companySetId' || me.model.get('benchmarkCompaniesFilter')) {
                partialDataPopover = RivalIQ.utils.incompleteData.getIncompleteDataPopover(primaryDimension, primaryDimensionId, me.model, calculationMetadata);
            }

            return {
                value: me.model.format(_.last(data)),
                width: 100 * RivalIQ.metric.data.rawValue(me.model, data) / (bounds[1] || 0),
                className: me.model.getClassName(data) || 'bar-competitor',
                labelClass: labelClass,
                color: color,
                tooltip: tooltip,
                showProgressBar: showProgressBar,
                partialDataPopover: partialDataPopover || null
            };
        }
    });

    views.Bar.updateCellsOnExpansion = function (model, tdEl, data, bounds) {
        const newWidth = 100 * RivalIQ.metric.data.rawValue(model, data) / (bounds[1] || 0);
        $(tdEl).find('.progress-bar').css('width', `${newWidth}%`);
    };

    views.SparklineTableCell = Marionette.ItemView.extend({
        tagName: 'td',
        template: '#metricTableSparklineTableCell',
        className: function () {
            const me = this;

            let classes = 'metric-table-cell sparkline-metric-table-cell ';
            if (me.showWideSparkline()) {
                classes += 'sparkline-metric-table-cell-wide';
            } else {
                classes += 'sparkline-metric-table-cell-narrow';
            }

            const table = me.getOption('table');
            const columnIndex = me.getOption('columnIndex');
            const summaryMetricAggregate = _.get(table.getProp('customSummaryMetrics'), [columnIndex - 1]);
            if (summaryMetricAggregate) {
                classes += ` summary-aggregate-${summaryMetricAggregate}`;
            }

            return classes;
        },

        showWideSparkline: function () {
            const me = this;

            const table = me.getOption('table');

            const isHalfWidth = (table.dashboardModel.getColumnWidth() === 6 && !table.dashboardModel.isFocus());
            const numSparklineCells = _.sumBy(table.metrics, function (metric) {
                return (metric.showSparkline ? 1 : 0);
            });

            if (isHalfWidth) {
                return numSparklineCells < 2 && _.size(table.metrics) < 4;
            }

            return (numSparklineCells < 7);
        },

        serializeData: function () {
            const me = this;

            const metric = me.model;
            const table = me.getOption('table');

            const mainPeriodValue = me.getOption('data');
            const companyId = _.head(mainPeriodValue);
            let companyPeriodValues;

            // For summary and benchmark rows, the companyId is the id of the benchmark compare against option.
            const isBenchmarkRow = _.find(RivalIQ.enums.benchmarkCompareAgainstOptions, {
                id: companyId
            });
            const isSummaryRow = (companyId === '__SUMMARY_ROW__');

            if (isBenchmarkRow || isSummaryRow) {
                const metricIdentity = metric.getIdentityForUniversalApi();
                const periodValueMetrics = (isBenchmarkRow ? table.benchmarkPeriodValueMetrics : table.summaryRowPeriodValueMetrics);
                const periodValueMetric = _.find(periodValueMetrics, function (benchmarkMetric) {
                    return benchmarkMetric && benchmarkMetric.get('_parent') === metricIdentity;
                });

                if (periodValueMetric) {
                    companyPeriodValues = [_.map(periodValueMetric.getValue({
                        format: false
                    }), _.last)];
                }
            } else {
                const periodValuesMetric = table.periodValues.findWhere({
                    _parent: metric.getIdentityForUniversalApi()
                });

                let companyPeriodValuesMetric = [];
                if (periodValuesMetric) {
                    // periodValuesMetric is the interval values (i.e. daily, weekly, or monthly) for `metric`. It's all the interval values for all possible rows here. That is,
                    // if we're looking at company table, periodValuesMetric data will have [[companyIdA, period1, periodValue1], ..., [companyIdN, periodN, periodValueN]] all in
                    // one array.
                    // We need to extract just the values for the row we're looking at. This is a little extra complex because we might be looking at a dimension table. E.g. if we
                    // have a companySet table with companyId as a secondary metric, the periodValuesMetric will be
                    // [[companySetIdA, companyIdA, period1, periodValue1], ..., [companySetIdX, companyIdN, periodN, periodValueN]]
                    // The code below will filter periodValuesMetric based on the dimensionValues of the row we're looking at.
                    const metrixFixedDimensions = metric.getFreeDimensions();
                    const periodValuesFixedDimensions = periodValuesMetric.getFreeDimensions();
                    const periodValuesFixedDimensionsByIdx = _.reduce(metrixFixedDimensions, function (memo, dimensionName, idx) {
                        const periodValuesIdx = periodValuesFixedDimensions.indexOf(dimensionName);
                        memo[periodValuesIdx] = mainPeriodValue && mainPeriodValue[idx];
                        return memo;
                    }, {});

                    const intervalDimension = _.head(_.difference(periodValuesFixedDimensions, metrixFixedDimensions));
                    const intervalDimensionIdx = periodValuesFixedDimensions.indexOf(intervalDimension);

                    companyPeriodValuesMetric = _(periodValuesMetric?.data)
                        .filter(periodValues => {
                            return _.every(periodValuesFixedDimensionsByIdx, (periodValuesFixedDimensionValue, periodValuesIdx) => {
                                return periodValues[periodValuesIdx] === periodValuesFixedDimensionValue;
                            });
                        })
                        .sortBy(intervalDimensionIdx) // make sure we're looking at interval data with date ascending
                        .map(_.last)
                        .value();
                }

                companyPeriodValues = [mainPeriodValue, companyPeriodValuesMetric];
            }

            let summaryType = null;
            if (isSummaryRow) {
                const columnIndex = me.getOption('columnIndex');
                const summaryMetricAggregate = _.get(table.getProp('customSummaryMetrics'), [columnIndex - 1]);
                if (summaryMetricAggregate) {
                    summaryType = RivalIQ.apps.Overview.utils.getSelectedBenchmarkCompareAgainst(summaryMetricAggregate).customSummaryName;
                }
            }

            let sparklineEl = null;
            if (companyPeriodValues) {
                let periodValues = null;
                if (_.isNumber(_.last(mainPeriodValue))) {
                    periodValues = _.last(companyPeriodValues);
                }
                sparklineEl = RivalIQ.graph.renderSparkline(periodValues, null, {
                    width: (me.showWideSparkline() ? RivalIQ.graph.wideSparklineWidth : RivalIQ.graph.defaultSparklineWidth)
                });
            }

            let tooltip = null;
            if (RivalIQ.metric.property.isNumeric(metric.attributes)) {
                let tipValue = '--';
                if (_.isNumber(_.last(mainPeriodValue))) {
                    tipValue = metric.formatExpanded(mainPeriodValue);
                }
                const showSourceIcons = table.dashboardModel.getCuration().isCustomDashboard;
                const tooltipTemplate = Marionette.TemplateCache.get('#tableCellTooltip');
                tooltip = tooltipTemplate({
                    name: metric.getName(),
                    value: tipValue,
                    sourceIcon: (showSourceIcons ? RivalIQ.enums.sourceDetails[metric.getSource()].iconSvg : null)
                });

                const privateDataNotConnectedTooltip = table._getPrivateDataNotConnectedTooltip && table._getPrivateDataNotConnectedTooltip(metric, companyId || _.get(me.options, ['rows', me.getOption('index'), 0, 0]));
                if (privateDataNotConnectedTooltip) {
                    tooltip = privateDataNotConnectedTooltip;
                }
            }

            return {
                tooltip: tooltip,
                sparklineHtml: _.get(sparklineEl, 'outerHTML'),
                value: metric.format(mainPeriodValue),
                summaryType: summaryType
            };
        }
    });

    const PresenceRank = views.PresenceRank = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'company-rank',
        template: '#socialPostsActivityCellTemplate',

        idDimension: 'presence_id',

        getId: function () {
            const me = this;
            const metric = me.model;
            const data = me.options.data;
            const dimension = me.getOption('idDimension');
            const id = RivalIQ.metric.dimensionValue(metric.attributes, dimension, data);
            return id;
        },

        getData: function (presenceId) {
            const me = this;
            const metric = me.model;

            const clone = metric.clone({
                presence_id: presenceId,
                property: 'summary_data'
            });

            const data = clone.getValue();

            return data;
        },

        serializeData: function () {
            const me = this;
            const presenceId = me.getId();
            const data = me.getData(presenceId);

            return _.extend({
                channel: RivalIQ.data.channels.get(me.model.get('channel')),
                href: null,
                index: me.options.index
            }, data, {
                handle: me.getHandle(data)
            });
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        },

        getHandle: function (data) {
            const me = this;
            const metric = me.model;
            const handle = _.get(data, 'handle');
            const channel = RivalIQ.data.channels.get(metric.get('channel'));
            if (handle && channel.id === RivalIQ.enums.sources.TWITTER) {
                return `@${handle}`;
            }
        }
    });

    views.CompanyRank = PresenceRank.extend({
        idDimension: 'companyId',

        getData: function (companyId) {
            const me = this;
            const company = RivalIQ.state.landscape.getCompanyById(companyId);

            return _.extend({
                href: `/company/${companyId}`,
                icon_url: company.getIcon(),
                isFocus: (company.id === me.options.props.focusCompanyId)
            }, company.toJSON());
        }
    });

    views.CompanySetRank = Marionette.ItemView.extend({
        tagName: 'td',
        className: 'company-rank',
        template: '#companySetCellTemplate',

        serializeData: function () {
            const me = this;

            const metric = me.model;
            const data = me.options.data;
            const companySetId = RivalIQ.metric.dimensionValue(metric.attributes, 'companySetId', data);
            const companySetName = (companySetId === '__SUMMARY_ROW__') ? 'Summary' : RivalIQ.state.utils.getCompanySetName(companySetId);

            return {
                index: me.options.index,
                name: companySetName,
                isSummaryRow: companySetId === '__SUMMARY_ROW__'
            };
        },

        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        }
    });

    views.PublishedAt = {
        tagName: 'td',
        render: function (metric, data) {
            let publishedAt = moment.utc(_.last(data));

            const timezone = metric.get('timezone');
            const tz = RivalIQ.utils.timezone.getTimezoneAbbreviation(timezone, publishedAt);
            publishedAt = RivalIQ.utils.timezone.getDateInTimezone(timezone, publishedAt);
            return Marionette.TemplateCache.get('#publishedAtCellTemplate')({
                dateStr: publishedAt.format('MMM D, YYYY'),
                timeStr: publishedAt.format('LT'),
                timezone: tz
            });
        }
    };

}, window.moment);
